import { useTranslations } from "next-intl";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { useReferralProgram } from "@hooks/use-features";
import Link from "@components/core/Link";
import redeemTypes from "@utils/constants/redeemTypes";
import { usePrice } from "@hooks/use-prices";
import ReferralTriptychCard from "./ReferralTriptychCard";

function ReferralTriptych() {
  const t = useTranslations("referrals");

  const {
    referree_coupon: referreeCoupon,
    referrer_subscription_credit_reward: referrerRewardInCents,
  } = useReferralProgram();
  const price = usePrice();

  const durationInMonths = parseInt(referreeCoupon.duration_in_months, 10) || 1;
  const referrerGainAmount = price(referrerRewardInCents, {
    withoutCents: true,
    withoutSpace: true,
  });
  const referreeBenefitAmount = price(referreeCoupon.value, {
    withoutCents: true,
    withoutSpace: true,
  });

  const referreeBenefitText = () => {
    switch (referreeCoupon.duration) {
      case "forever":
        switch (referreeCoupon.type) {
          case redeemTypes.couponPercentOff:
            return t.rich("triptych_card2.content.percent_off_forever", {
              percent: referreeCoupon.value,
            });
          case redeemTypes.couponAmountOff:
            return t.rich("triptych_card2.content.amount_off_forever", {
              amount: referreeBenefitAmount,
            });
        }
        break;
      case "once":
        switch (referreeCoupon.type) {
          case redeemTypes.couponPercentOff:
            return t.rich("triptych_card2.content.percent_off", {
              percent: referreeCoupon.value,
              count: durationInMonths,
            });
          case redeemTypes.couponAmountOff:
            return t.rich("triptych_card2.content.amount_off", {
              amount: referreeBenefitAmount,
              count: durationInMonths,
            });
        }
    }
  };

  const triptychCards = [
    {
      title: t("triptych_card1.title"),
      content: t("triptych_card1.content"),
      imgName: "bonusRetro",
      imgAlt: t("triptych_card1.imgAlt"),
    },
    {
      title: t("triptych_card2.title"),
      content: referreeBenefitText(),
      imgName: "partyNature",
      imgAlt: t("triptych_card2.imgAlt"),
    },
    {
      title: t("triptych_card3.title"),
      content: t.rich("triptych_card3.content", {
        referrer_gain: referrerGainAmount,
        link: (chunks) => (
          <Link
            className="link-primary"
            href="/profile/referral-details"
          >
            {chunks}
          </Link>
        ),
      }),
      imgName: "giftRetro",
      imgAlt: t("triptych_card3.imgAlt"),
    },
  ];

  return (
    <div className="d-flex flex-column text-center py-6">
      <h4 className="pb-2 mb-4 pb-md-0 mb-md-5 mx-3">{t("triptych_title")}</h4>

      <div className="w-100 d-flex justify-content-center">
        <Swiper
          modules={[Pagination]}
          className="referral-triptych-swiper"
          pagination={{ clickable: true }}
          spaceBetween={24}
          breakpoints={{
            0: {
              slidesPerView: 1,
              pagination: {
                clickable: true,
              },
            },
            992: {
              slidesPerView: 3,
              pagination: {
                clickable: false,
              },
            },
          }}
        >
          {triptychCards.map((card, index) => (
            <SwiperSlide key={`swiper-slide-${index + 1}`}>
              <ReferralTriptychCard
                card={card}
                key={card.title}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default ReferralTriptych;
